import React, { useState } from 'react';
import Modal from '../../../../../../component/modal/Modal';
import InputField from '../../../../../../component/form/FormInput';
import Button from '../../../../../../component/ui/Button';
import cardIcon from '../../../../../../assets/image/subscription/card-icon.svg';
import { toast } from 'react-toastify';

export default function NewCardModal({ isOpenModal, setIsOpenModal, getList }) {
	const [error, setError] = useState({});
	const [loader, setLoader] = useState(false);
	const [cardDetails, setCardDetails] = useState({
		card_holder_name: '',
		card_number: '',
		card_expiry_date: '',
		card_cvv_number: '',
	});
	function handleFormData(name, val, required = false) {
		setCardDetails((prev) => ({
			...prev,
			[name]: val,
		}));
		let newError = { ...error };
		if (required) {
			if (val) {
				delete newError[name];
			} else {
				newError[name] = `Please enter ${name.replaceAll('_', ' ')} in the field`;
			}
		}
	}
	const checkValidation = () => {
		const newError = { ...error };
		if (
			!newError.card_holder_name ||
			newError.card_holder_name === undefined ||
			newError.card_holder_name === null
		) {
			newError.card_holder_name = 'Please enter card holder name in the field';
		} else {
			delete newError.card_holder_name;
		}
		if (
			!newError.card_number ||
			newError.card_number === undefined ||
			newError.card_number === null
		) {
			newError.card_number = 'Please enter card number in the field';
		} else {
			delete newError.card_number;
		}
		if (
			!newError.card_expiry_date ||
			newError.card_expiry_date === undefined ||
			newError.card_expiry_date === null
		) {
			newError.card_expiry_date = 'Please enter card expiry date in the field';
		} else {
			delete newError.card_expiry_date;
		}
		if (
			!newError.card_cvv_number ||
			newError.card_cvv_number === undefined ||
			newError.card_cvv_number === null
		) {
			newError.card_cvv_number = 'Please enter card cvv number in the field';
		} else {
			delete newError.card_cvv_number;
		}
		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	};

	const handleSave = () => {
		let isError = checkValidation();
		if (isError) {
			toast.error('Unable to create new card details of bank');
		} else {
			try {
				setLoader(true);
				setIsOpenModal(false);
			} catch (error) {
			} finally {
				setLoader(false);
			}
		}
	};

	return (
		<Modal
			className="subscription-modal"
			title={`Card Details`}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div>
				<div className="col my-3">
					<InputField
						label="Card Holder Name"
						placeholder="Card holder name"
						type="text"
						required={true}
						value={cardDetails.card_holder_name}
						onChange={(value) => handleFormData('card_holder_name', value, true)}
						error={error.card_holder_name}
					/>
				</div>
				<div className="col my-3">
					<InputField
						label="Card Number"
						placeholder="Card number"
						type="text"
						required={true}
						value={cardDetails.card_number}
						onChange={(value) => handleFormData('card_number', value, true)}
						error={error.card_number}
						rightIcon={{
							src: cardIcon,
							alt: 'card-icon',
							onClick: () => {},
						}}
					/>
				</div>
				<div className="row my-3">
					<div className="col">
						<InputField
							label="Expiration Date"
							placeholder="Expiration Date"
							type="date"
							value={cardDetails.card_expiry_date}
							required={true}
							error={error?.card_expiry_date}
						/>
					</div>
					<div className="col">
						<InputField
							label="CVV"
							placeholder="CVV"
							type="text"
							required={true}
							value={cardDetails.card_cvv_number}
							onChange={(value) => handleFormData('card_cvv_number', value, true)}
							error={error.card_cvv_number}
						/>
					</div>
				</div>
				<div className="d-flex justify-content-end my-4">
					<Button
						type="button"
						className="mt-0 btn-primary rounded-4 text-white fs-5 fw-light add-pro py-3 px-5 "
						button="Verify"
						disabled={loader}
						loader={loader}
						onClick={() => {
							handleSave();
						}}
					/>
				</div>
			</div>
		</Modal>
	);
}
